module.exports = __webpack_public_path__ + "static/img/logo08.6614f5e2.png";